export default __webpack_public_path__ + "static/tanis-twitter-37edb5092e28e7c45eb2ff1f45284331.jpeg";